import VocSwitch from "./src/main"

/* istanbul ignore next */
VocSwitch.install = function (Vue) {
  Vue.component(VocSwitch.name, VocSwitch)
}

export default VocSwitch
